import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';

export class UserApi {
    private instance: AxiosInstance;
    siteTag: string;

    constructor(siteTag?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.siteTag = siteTag ? siteTag : "";
    }

    async getUserExists(username: string): Promise<boolean> {
        let response = await this.instance.get<boolean>('/' + this.siteTag + '/usernamelookup?username=' + encodeURI(username));
        return response.data;
    }

    async getEmailExists(email: string): Promise<boolean> {
        let response = await this.instance.get<boolean>('/' + this.siteTag + '/emaillookup?email=' + encodeURI(email));
        return response.data;
    }

    async postRecovery(email: string, languageCode: string): Promise<boolean> {
        const config: AxiosRequestConfig = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            
        };

        const params = new URLSearchParams();
        params.append('email', email);

        let response = await this.instance.post('/' + this.siteTag + '/recover/' + languageCode + '/reset-password?LoginAction=Recovery', params, config);

        if (response.status == 200) {
            return Promise.resolve<boolean>(true);
        } else {
            return Promise.resolve<boolean>(false);
        }
    }
}